import React from 'react'
import BaseBtn from './BaseBtn'
import { USER_ACTIONS } from '../../../../../data/Constant'

const EditBtn = ({onApply,id }) => {
  return (
    <BaseBtn icon={"fluent:cloud-edit-16-regular"} className='update' reqAction={USER_ACTIONS.UDPATE} onApply={() => onApply(id)} />
  )
}

export default EditBtn